<div
  class="modal"
  [ngClass]="{ 'modal--open': isOpen, 'modal--right-aligned': isRightAligned }"
  (click)="onClose()"
  (keydown.enter)="$event.stopPropagation()">
  <div
    class="{{ className }}"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()">
    <header class="modal__header" [ngClass]="{ 'modal__header--centered': isCentered }">
      <h2 class="modal__title" [ngClass]="{ 'modal__title--bold': isBold }">
        {{ title }}
      </h2>
      <div *ngIf="showSeparator" class="modal__separator"></div>
    </header>
    <div class="modal__header-actions">
      <ng-template #headerActions></ng-template>
    </div>
    <button *ngIf="showCloseButton" class="modal__close-button" (click)="onClose()">
      <img [src]="closeIcon" alt="close" />
    </button>

    <div class="modal__content">
      <ng-template #content></ng-template>
    </div>
  </div>
</div>
